import React, { useState, useEffect, useMemo, useContext } from 'react';
import { LegacyStack} from '@shopify/polaris';
import { RegistrationsContext } from '../../contexts/Registrations'
import { SectionsContext } from '../../contexts/yolk/Sections'
import { ProductsContext } from '../../contexts/Products'
import Productable from '../../concerns/Productable'
import {formatDate} from '../../DateUtil';

export default function RegistrationRow(props) {
  const registrations = useContext(RegistrationsContext)
  const [products] = useContext(ProductsContext);
  const [sections] = useContext(SectionsContext);

  const registration = registrations.find((r) => r.id == props.id)
  if(!registration) {
    throw Error(`no registration found for id ${props.id} in : ${registrations.map((r) => r.id)}`)
  }

  const discount = Productable.price(products, registration)
  const imageSrc = Productable.imageSrc(products, registration)

  return (<tr className={`registration-row`}>
      <td className="thumbnail"><img src={imageSrc}/></td>
      <td>
        <span className="name">{registration.title}</span>
      </td>
      <td className="">
        <form className="registration-form" action="/cart/add" method="port">
          <input type="hidden" name="properties[_discount]" value={discount} />
          <input type="hidden" name="id" value={registration.variant_id_full(products)} />
          <input type="submit" className="button small orange registration-link" value="Complete Payment"/>
        </form>
      </td>
      <td colSpan="6" style={{textAlign: 'center'}}>{`Starts on ${formatDate(registration.start_at(sections))}`}</td>
    </tr>)
}
